
import { ISDKInfo } from '@kontent-ai/core-sdk';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '12.0.2',
    name: '@kontent-ai/delivery-sdk'
};
